let currentFlyout = null;

const openFlyoutNav = (item) => {
    const atag = document.getElementById(item);
    const flyout = document.getElementById(item + '-flyout');

    if (currentFlyout !== null && currentFlyout !== flyout) {
        const prevAnchorTag = currentFlyout.previousElementSibling;
        if (prevAnchorTag) {
            prevAnchorTag.classList.remove('flyout-active');
        }
        currentFlyout.classList.remove('flyout-active');
    }

    if (atag.classList.contains('flyout-active')) {
        atag.classList.remove('flyout-active');
        if (flyout) {
            flyout.classList.remove('flyout-active');
        }
        currentFlyout = null;
    } else {
        atag.classList.add('flyout-active');
        if (flyout) {
            flyout.classList.add('flyout-active');
        }
        currentFlyout = flyout;
    }
};

const closeAllFlyouts = () => {
    const flyouts = document.querySelectorAll('.flyout-active');
    flyouts.forEach((flyout) => {
        const prevAnchorTag = flyout.previousElementSibling;
        if (prevAnchorTag) {
            prevAnchorTag.classList.remove('flyout-active');
        }
        flyout.classList.remove('flyout-active');
    });
    currentFlyout = null;
};

const mobileNav = () => {
    const nav = document.getElementById('mobile-nav');
    const flyout = document.querySelectorAll('.flyout-active');

    if (nav.classList.contains('mobile-active')) {
        nav.classList.remove('mobile-active');

        if (flyout != null) {
            flyout.forEach((item) => {
                item.classList.remove('flyout-active');
            });
        }
    } else {
        nav.classList.add('mobile-active');
    }
};

// Function to toggle the search-active class on .mobile-search
const toggleSearchActive = () => {
    const mobileSearch = document.querySelector('.mobile-search');
    mobileSearch.classList.toggle('search-active');
};

// Function to handle text sizing buttons
const handleTextSizeButtons = () => {
    const regularButton = document.querySelector('.text-size_regular');
    const largeButton = document.querySelector('.text-size_large');
    const htmlElement = document.documentElement;

    if (regularButton != null) {
        regularButton.addEventListener('click', () => {
            if (!regularButton.classList.contains('active')) {
                regularButton.classList.add('active');
                largeButton.classList.remove('active');
                htmlElement.classList.remove('large-font');
            }
        });
    }

    if (largeButton != null) {
        largeButton.addEventListener('click', () => {
            if (!largeButton.classList.contains('active')) {
                largeButton.classList.add('active');
                regularButton.classList.remove('active');
                htmlElement.classList.add('large-font');
            }
        });
    }
};

// Function to handle toggling search overlay
const handleSearchOverlay = () => {
    const searchToggleOpen = document.querySelector('.search-toggle--open');
    const searchToggleClose = document.querySelector('.search-toggle--close');
    const searchOverlay = document.querySelector('.search-overlay');

    const toggleSearchOverlay = () => {
        searchToggleOpen.classList.toggle('is-active');
        searchToggleClose.classList.toggle('is-active');
        searchOverlay.classList.toggle('is-active');
    };

    if (searchToggleOpen != null) {
        searchToggleOpen.addEventListener('click', toggleSearchOverlay);
    }

    if (searchToggleClose != null) {
        searchToggleClose.addEventListener('click', toggleSearchOverlay);
    }
};

const handleSearchOverlayMobile = () => {
    const searchMobToggleOpen = document.querySelector('.search-toggle-mob--open');
    const searchMobToggleClose = document.querySelector('.search-toggle-mob--close');
    const searchMobOverlay = document.querySelector('.search-overlay--mob');

    const toggleSearchOverlayMobile = () => {
        searchMobToggleOpen.classList.toggle('is-active');
        searchMobToggleClose.classList.toggle('is-active');
        searchMobOverlay.classList.toggle('is-active');
    };

    if (searchMobToggleOpen != null) {
        searchMobToggleOpen.addEventListener('click', toggleSearchOverlayMobile);
    }

    if (searchMobToggleClose != null) {
        searchMobToggleClose.addEventListener('click', toggleSearchOverlayMobile);
    }
};

// Event Listeners

    // Call handleTextSizeButtons to set up text size button event listeners
    handleTextSizeButtons();

    // Add click event listener for .mobile-search-btn to toggle search-active class
    const mobileSearchBtn = document.querySelector('.mobile-search-btn');

    if (mobileSearchBtn) {
        mobileSearchBtn.addEventListener('click', (event) => {
            // Add click event listener for .mobile-search div to close the search input
            console.log('clicked!');
            toggleSearchActive();
        });
    }

    // Add click event listener for the mobile menu button
    const mobileOpen = document.querySelector('.open');
    const mobileClose = document.querySelector('.close');

    if (mobileOpen != null) {
        mobileOpen.addEventListener('click', mobileNav);
    }

    if (mobileClose != null) {
        mobileClose.addEventListener('click', mobileNav);
    }

    // Event delegation for nav items with flyouts
    const nav = document.querySelector('.nav')
    
    if (nav != null) {
        nav.addEventListener('click', (event) => {
            const clickedNavItem = event.target.closest('.has-flyout');
            if (clickedNavItem) {
                const itemId = clickedNavItem.id;
                openFlyoutNav(itemId);
            }
        });
    }

    // Determine which anchor tags need the has-flyout class
    const listItems = document.querySelectorAll('.nav ul li');
    listItems.forEach((item) => {
        const flyout = item.querySelector('div[id$="-flyout"]');
        const anchorTag = item.querySelector('a');

        if (flyout && anchorTag) {
            anchorTag.classList.add('has-flyout');
        }
    });

    // Event listener to close flyouts when .background-blur is clicked for each flyout
    const backgroundBlurElements = document.querySelectorAll('.background-blur');
    backgroundBlurElements.forEach((backgroundBlur) => {
        backgroundBlur.addEventListener('click', closeAllFlyouts);
    });

    // Call handleSearchOverlay to set up search overlay event listeners
    handleSearchOverlay();
    handleSearchOverlayMobile();

export {
    toggleSearchActive,
    handleTextSizeButtons,
    handleSearchOverlay,
    handleSearchOverlayMobile,
    openFlyoutNav,
    mobileNav
};
